import Hero from './hero';
import CoreCapability from './CoreCapabilities';
import Last from './lastsection.jsx';

export default function DefenceOverview() {
  return (
    <>
      <Hero />
      <CoreCapability />
      <Last />
    </>
  );
}
